import styled from 'styled-components'

export default styled.span`
  width: 22px;
  height: 11px;
  cursor: pointer;
  background-image: url('${props => props.theme.email.full.toggleIcon.background}');
  color: ${props => props.read ? '#333' : '#2c6796'};
  background-position: 0 ${props => props.active ? '0' : '-19px'};
  &:hover {
    background-position: 0 ${props => props.active ? '-40px' : '-59px'};
  }
`
